export default "/images/e0b163c91bdcf266f6c5f4127f1c1c13.avif";